import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import ArticleCard from '@/components/base/ArticleCard';
import FAQSection from '@/components/base/FAQSection';
import { articles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';
import { faqs } from '@/mocks/faqs';

const entranceLinks = [
  { label: '主入口 1', url: '#', status: '正常', speed: '快速' },
  { label: '主入口 2', url: '#', status: '正常', speed: '快速' },
  { label: '主入口 3', url: '#', status: '正常', speed: '稳定' },
  { label: '镜像 1', url: '#', status: '正常', speed: '较快' },
  { label: '镜像 2', url: '#', status: '正常', speed: '较快' },
  { label: '镜像 3', url: '#', status: '待验证', speed: '一般' },
];

const statsData = [
  { value: '12+', label: '可用入口' },
  { value: '50+', label: '教程文章' },
  { value: '99.9%', label: '可用率' },
  { value: '24/7', label: '持续更新' },
];

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const featuredArticles = articles.slice(0, 6);
  const homepageFaqs = faqs.slice(0, 6);

  return (
    <>
      <SchemaOrg
        type="WebSite"
        data={{
          name: '草榴社区入口导航',
          description: '草榴社区入口是广大用户访问草榴社区的核心渠道，提供最新可用入口地址、镜像备用链接及访问指南。',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://caoliu-entrance.com/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '草榴社区入口导航',
          description: '最全面的草榴社区入口导航平台',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'contact@caoliu-nav.com',
            contactType: 'customer service',
            availableLanguage: ['Chinese'],
          },
        }}
      />

      <Navbar />

      <main>
        <section className="relative w-full h-[480px] md:h-[600px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20glowing%20digital%20gateway%20portal%20with%20golden%20amber%20light%20rays%20radiating%20from%20center%2C%20dark%20rich%20background%20with%20subtle%20geometric%20patterns%2C%20modern%20minimal%20aesthetic%2C%20sophisticated%20tech%20vibe%2C%20warm%20inviting%20atmosphere%2C%20no%20blue%20or%20purple%20colors%2C%20elegant%20dark%20brown%20and%20gold%20tones&width=1600&height=900&seq=hero-main-bg&orientation=landscape"
            alt="草榴社区入口 Hero 背景"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>

          <div className="relative z-10 w-full text-center px-4">
            <div className="max-w-3xl mx-auto">
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-5 leading-tight">
                草榴社区入口
              </h1>
              <p className="text-sm md:text-lg text-background-200/90 mb-4 max-w-xl mx-auto leading-relaxed">
                官方直达通道 — 汇聚最新可用入口地址与访问指南
              </p>
              <p className="text-xs md:text-sm text-background-300/80 mb-8 max-w-lg mx-auto">
                告别封锁烦恼，获取最新草榴社区入口、镜像备用链接及详细访问方法
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                <a
                  href="#entrances"
                  className="px-7 py-3 bg-primary-500 text-background-50 rounded-md font-medium text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  查看最新入口
                </a>
                <Link
                  to="/category/access-guide"
                  className="px-7 py-3 bg-background-50/15 text-background-50 border border-background-50/30 rounded-md font-medium text-sm hover:bg-background-50/25 transition-all duration-200 cursor-pointer whitespace-nowrap"
                >
                  访问指南
                </Link>
              </div>
            </div>
          </div>

          <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
            <a href="#entrances" className="text-background-50/60 hover:text-background-50 transition-colors cursor-pointer">
              <i className="ri-arrow-down-line text-2xl"></i>
            </a>
          </div>
        </section>

        <section className="py-8 bg-background-50 border-b border-background-200/50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
              {statsData.map((stat) => (
                <div key={stat.label} className="text-center py-4">
                  <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">{stat.value}</div>
                  <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section id="entrances" className="py-14 md:py-20 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                最新可用入口
              </h2>
              <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                以下是当前验证可用的草榴社区入口地址，持续监控更新中
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {entranceLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.url}
                  className="flex items-center justify-between p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer group"
                >
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 flex items-center justify-center bg-primary-100 text-primary-600 rounded-lg">
                      <i className="ri-link text-base"></i>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors block">
                        {link.label}
                      </span>
                      <span className="text-xs text-foreground-400">{link.speed}</span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <span className="flex items-center gap-1 text-xs text-emerald-600">
                      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500"></span>
                      {link.status}
                    </span>
                    <i className="ri-external-link-line text-foreground-300 group-hover:text-primary-500 transition-colors text-sm"></i>
                  </div>
                </a>
              ))}
            </div>

            <div className="text-center mt-8">
              <Link
                to="/category/latest-entrance"
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap"
              >
                查看全部入口
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                浏览分类
              </h2>
              <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                按需求浏览不同分类的文章内容，快速找到所需信息
              </p>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
              {categories.map((cat) => (
                <Link
                  key={cat.id}
                  to={`/category/${cat.slug}`}
                  className="flex flex-col items-center gap-3 p-5 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-200/60 transition-all duration-200 cursor-pointer group"
                >
                  <div className="w-11 h-11 flex items-center justify-center bg-accent-100 text-accent-600 rounded-lg group-hover:bg-accent-500 group-hover:text-background-50 transition-all duration-200">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                    {cat.name}
                  </span>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="max-w-6xl mx-auto px-4 md:px-6">
            <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
              <div>
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                  最新文章
                </h2>
                <p className="text-sm text-foreground-500">
                  精选访问指南与社区资讯
                </p>
              </div>
              <Link
                to="/category/latest-entrance"
                className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
              >
                查看全部
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuredArticles.map((article) => (
                <ArticleCard key={article.id} {...article} />
              ))}
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
                常见问题
              </h2>
              <p className="text-sm text-foreground-500">
                关于草榴社区入口访问的常见疑问解答
              </p>
            </div>

            <FAQSection faqs={homepageFaqs} />
          </div>
        </section>

        <section className="py-14 md:py-20 relative overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Abstract%20warm%20golden%20amber%20gradient%20flowing%20lines%20with%20soft%20coral%20accents%2C%20dark%20rich%20base%2C%20elegant%20modern%20design%2C%20inviting%20atmosphere%2C%20no%20blue%20purple%20colors%2C%20sophisticated%20tech%20theme&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
            alt="CTA 背景"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

          <div className="relative z-10 max-w-2xl mx-auto text-center px-4">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
              找不到入口？我们来帮您
            </h2>
            <p className="text-sm md:text-base text-background-200/90 mb-8 max-w-md mx-auto">
              收藏本站，随时获取草榴社区最新可用入口地址。我们持续监控，确保您始终能连接。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-7 py-3 bg-accent-500 text-background-50 rounded-md font-medium text-sm hover:bg-accent-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              了解更多
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}